;(function (angular, _) {
  'use strict'

  class ChorusHistoryContainer {
    constructor (
      // Angular
      $rootScope, $state,
      // Libs
      // Managers
      ChorusHistoryManager,
      // Services
      ChorusService, SnackService
      // Const
      // Resolved
    ) {
      this.chorusService = ChorusService
      this.snackService = SnackService
      this.$rootScope = $rootScope
      this.$state = $state
      this.chorusHistoryManager = ChorusHistoryManager
      this.loading = false
      this.histories = []
      this.showHistories = false
    }

    $onInit () {
    }

    synchronize () {
      this.$rootScope.loadingPage = true
      return this.chorusService.rattacherHistorique(
        this.chorusInvoice,
        this.elementId,
        this.isCreditNote).then(() => {
        this.$state.reload()
        this.$rootScope.loadingPage = false
        this.snackService.snack({
          text: `Historique mis à jour !`,
          delay: 5000
        })
      })
    }

    show () {
      this.showHistories = !this.showHistories
      if (!this.showHistories) return
      const query = {}
      this.isCreditNote ? query.creditNoteRef = this.elementId : query.invoiceRef = this.elementId
      this.loading = true
      return this.chorusHistoryManager.postFilters(query).then((response) => {
        this.histories = this.chorusHistoryManager.build(response.data)
      }).catch((error) => {
        console.error(error)
      }).finally(() => {
        this.loading = false
      })
    }
  }

  ChorusHistoryContainer.$inject = [
    // Angular
    '$rootScope', '$state',
    // Libs
    // Managers
    'ChorusHistoryManager',
    // Services
    'ChorusService', 'SnackService'
    // Const
    // Resolved
  ]

  angular.module('kilo.common.components')
    .component('chorusHistoryContainer', {
      bindings: {
        chorusInvoice: '<',
        elementId: '<',
        isCreditNote: '<'
      },
      controllerAs: '$ctrl',
      templateUrl: '/app/common/components/chorus-history/chorus-history-container.component.html',
      controller: ChorusHistoryContainer
    })
})(window.angular, window._)
